/**
 * Remembers the chosen folder between visits. A FileSystemDirectoryHandle can
 * be stored in IndexedDB; the browser may still ask to allow it again.
 */

const DB = "looseleaf-handles";
const STORE = "handles";
const KEY = "folder";

function open(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB, 1);
    request.onupgradeneeded = () => request.result.createObjectStore(STORE);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function run<T>(
  mode: IDBTransactionMode,
  fn: (store: IDBObjectStore) => IDBRequest<T>,
): Promise<T> {
  const db = await open();
  return new Promise<T>((resolve, reject) => {
    const tx = db.transaction(STORE, mode);
    const request = fn(tx.objectStore(STORE));
    tx.oncomplete = () => {
      db.close();
      resolve(request.result);
    };
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
}

export function saveFolder(handle: FileSystemDirectoryHandle) {
  return run("readwrite", (s) => s.put(handle, KEY));
}

export function loadFolder(): Promise<FileSystemDirectoryHandle | undefined> {
  return run<FileSystemDirectoryHandle | undefined>("readonly", (s) => s.get(KEY));
}

export function forgetFolder() {
  return run("readwrite", (s) => s.delete(KEY));
}
